import { BehaviorSubject } from 'rxjs'

export enum MainNavState {
  static,
  scrolled
}

export const mainNavState = new BehaviorSubject<MainNavState>(MainNavState.static)
